import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import version from './Version';

export default function Copyright({text = 'Synescent', href = 'https://synescent.com'}) {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href={href}>
        {text}
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const ApplicationName = `TICIT Version ${version.number}`;

export {
  ApplicationName
}